import { Flex, useMediaQuery } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Button from 'components/Button';
import Drawer from 'components/Drawer';
import Tabs, { TabHeader, TabPanels } from 'components/Tabs';
import ImportTasks from 'containers/JobsTasks/RightDrawer/ImportTasks';
import ControlSwitch from 'containers/JobsTasks/shared/ControlSwitch';
import { routePaths } from 'global/routePaths';
import { useFetchTabItemCountByModule } from 'hooks/common/useFetchTabItemCountsByModule';

import Active from './Active';
import Deactivated from './Deactivated';

const TasksTabs: React.FC<unknown> = () => {
  const { t } = useTranslation(['jobsTasks', 'common']);

  const tabPanels = [{ panel: <Active /> }, { panel: <Deactivated /> }];
  const [tabHeaders, setTabHeaders] = useState<any>([{ label: t('common:active') }, { label: t('common:inactive') }]);

  const navigate = useNavigate();
  const [isLargerThan768] = useMediaQuery(['(min-width: 768px)'], { ssr: false });

  const { data } = useFetchTabItemCountByModule('task');

  useEffect(() => {
    if (data) {
      const { active, deactivated } = data?.payload;

      const updatedTabHeaders = [
        { label: t('common:active'), count: active },
        { label: t('common:inactive'), count: deactivated },
      ];
      setTabHeaders(updatedTabHeaders);
    }
  }, [data, t]);

  return (
    <Tabs>
      <Flex justifyContent="space-between" flexDirection={{ base: 'column', md: 'row' }}>
        {!isLargerThan768 && (
          <Flex justifyContent="center" mb="2">
            <ControlSwitch />
          </Flex>
        )}
        <TabHeader tabHeaders={tabHeaders} />
        {isLargerThan768 && <ControlSwitch />}
        <Flex justifyContent="flex-end">
          <Drawer
            drawerTrigger={onOpen => (
              <Button colorScheme="secondary" mt={{ base: '5', md: '0' }} mr={3} onClick={onOpen}>
                {t('jobsTasks:importTasks')}
              </Button>
            )}
          >
            {onClose => <ImportTasks onClose={onClose} />}
          </Drawer>

          <Button
            colorScheme="secondary"
            mt={{ base: '5', md: '0' }}
            onClick={() => navigate(routePaths.jobsAndTasks.addTask)}
          >
            {t('jobsTasks:addTask')}
          </Button>
        </Flex>
      </Flex>
      <TabPanels tabPanels={tabPanels} />
    </Tabs>
  );
};

export default TasksTabs;
